/**
 * Definición canónica del checklist de cierre de proyecto.
 *
 * FUENTE DE VERDAD: `src/constants/closureChecklist.json` (este módulo sólo lo
 * re-exporta con nombres). Es un `.json` a propósito y no un `.js`: el carril
 * MCP (`mcp-server/`) despliega en Vercel con **Root Dir = mcp-server**, así que
 * no puede *importar* nada de `src/` en runtime — pero su gate de build sí puede
 * **leer** este archivo del repo (precedente vivo:
 * `mcp-server/tests/services/personaSinAllowedTools.test.js`, que lee
 * `.wiki/Agents/` del root dentro de `npm run test:predeploy`).
 *
 * Por eso el par es:
 *   - web   → importa este módulo (`src/services/closureService.js`)
 *   - MCP   → `mcp-server/src/constants/closureChecklist.js` (espejo en ESM)
 *   - gate  → `mcp-server/tests/services/closureChecklistParity.test.js` compara
 *             el espejo contra ESTE json y **rompe el deploy del mcp-server** si
 *             divergen.
 *
 * O sea: no hay import compartido posible con esta topología de deploy, pero sí
 * hay una sola fuente y un gate que convierte la divergencia silenciosa en un
 * build rojo. Si alguien agrega/edita/borra un ítem, tiene que tocar el json.
 *
 * Contexto de por qué existe (medido en prod el 2026-07-30):
 *   - El carril MCP (`initiate_project_closure`) sembraba estos 7 ítems.
 *   - El carril WEB no sembraba nada: el wizard mostraba una copia local en
 *     `useState` que nunca se persistía. Duplicar la lista una tercera vez para
 *     arreglarlo habría garantizado la próxima deriva.
 *
 * @module constants/closureChecklist
 */

import closureChecklist from './closureChecklist.json';

/** `project_checklists.checklist_type` del checklist de cierre. */
export const CLOSURE_CHECKLIST_TYPE = closureChecklist.checklist_type;

/** `project_checklists.title`. */
export const CLOSURE_CHECKLIST_TITLE = closureChecklist.title;

/** `project_checklists.is_required` — el cierre lo exige. */
export const CLOSURE_CHECKLIST_IS_REQUIRED = closureChecklist.is_required;

/**
 * Los 7 ítems, en orden.
 *
 * OJO con el esquema real (migración 027, verificado contra information_schema):
 * `project_checklist_items` **no tiene** columna `is_required` — "requerido" sólo
 * existe a nivel del checklist padre. El `is_required` de cada ítem acá es una
 * anotación de intención a nivel fuente (misma convención que ya usaba
 * `closureTools.js`) y NO se envía en el insert.
 */
export const CLOSURE_CHECKLIST_ITEMS = closureChecklist.items;

const closureChecklistDefinition = {
  CLOSURE_CHECKLIST_TYPE,
  CLOSURE_CHECKLIST_TITLE,
  CLOSURE_CHECKLIST_IS_REQUIRED,
  CLOSURE_CHECKLIST_ITEMS,
};

export default closureChecklistDefinition;
